import axios from 'axios';
import * as types from './actionTypes';
import { handleError } from '../errors/handleError';
import { checkProjectConfig } from './projectConfigActions';

export function errorHandler(dispatch, error, type) {
    const errorMessage = handleError(error);

    dispatch({
        type,
        error: errorMessage,
    });
}

export function getProjectVersionMenuItems(projectId) {
    return function (dispatch) {
        dispatch({
            type: types.GET_PROJECT_VERSION_MENUITEMS_PENDING,
        });
        return axios.get(`${window.GENESIS_CMS_API_URL}/v3/menu/${projectId}/menus/latest?sessionId=${localStorage.getItem('SessionId')}&token=${localStorage.getItem('AuthToken')}`)
            .then((response) => {
                dispatch({
                    type: types.GET_PROJECT_VERSION_MENUITEMS_SUCCESS,
                    payload: response.data,
                });
            })
            .catch((error) => {
                errorHandler(dispatch, error.response, types.GET_PROJECT_VERSION_MENUITEMS_FAILED);
            });
    };
}

export function updateMenuItemParameter(projectId, subTypeId, menu, field, value) {
    return function (dispatch) {
        dispatch({
            type: types.UPDATE_MENUITEM_PARAMETER_PENDING,
        });
        return axios.put(
            `${window.GENESIS_CMS_API_URL}/v3/menu/${projectId}/menuItem/latestsingle?sessionId=${localStorage.getItem('SessionId')}&menuSubTypeId=${subTypeId}&menuTypeId=${menu}&token=${localStorage.getItem('AuthToken')}`,
            {
                parameterName: field,
                parameterValue: value,
            },
        )
            .then((response) => {
                return Promise.all([
                    dispatch({
                        type: types.UPDATE_MENUITEM_PARAMETER_SUCCESS,
                        payload: response.data,
                    }),
                    dispatch(getProjectVersionMenuItems(projectId)),
                    dispatch(checkProjectConfig(projectId)),
                    dispatch({
                        type: types.SHOW_NOTIFICATION,
                    }),
                    setTimeout(() => {
                        dispatch({ type: types.HIDE_NOTIFICATION });
                    }, 7000),
                ]);
            })
            .catch((error) => {
                errorHandler(dispatch, error.response, types.UPDATE_MENUITEM_PARAMETER_FAILED);
            });
    };
}

export function bulkUpdateMenuItems(projectId, menuItems) {
    return function (dispatch) {
        dispatch({
            type: types.UPDATE_MENUITEMS_PENDING,
        });
        return axios({
            url: `${window.GENESIS_CMS_API_URL}/v3/menu/${projectId}/menulatest?sessionId=${localStorage.getItem('SessionId')}&token=${localStorage.getItem('AuthToken')}`,
            data: menuItems,
            method: 'PUT',
        })
            .then((response) => {
                return Promise.all([
                    dispatch({
                        type: types.UPDATE_MENUITEMS_SUCCESS,
                        payload: response.data,
                    }),
                    dispatch(checkProjectConfig(projectId)),
                    dispatch({
                        type: types.SHOW_NOTIFICATION,
                    }),
                    setTimeout(() => {
                        dispatch({ type: types.HIDE_NOTIFICATION });
                    }, 7000),
                ]);
            })
            .catch((error) => {
                errorHandler(dispatch, error.response, types.UPDATE_MENUITEMS_FAILED);
            });
    };
}
